var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imageFound)?_c('BImg',{attrs:{"src":_vm.src,"width":_vm.width,"height":_vm.width,"alt":_vm.alt}}):_c('span',{staticClass:"icon-holder p-2 d-flex bg-light border rounded"},[_c('FrIcon',{class:['md-24 text-dark mt-auto', _vm.inputClass],attrs:{"name":_vm.fallback}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }